import { useMutation, useQueryClient } from '@tanstack/react-query'
import type {
  UserVideoKYCStartInput,
  UserQuickKYCInput,
  UserAddVideoDocumentInput,
  UserQuickKYCVerifyInput,
} from '../api'
import type { IMutationArgs } from '../types'
import kycService from './user-kyc.service'
import { EUserAuthQueryKey } from '../user-auth'

export const useUserKyc = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (data: UserQuickKYCInput) => kycService.quick(data),
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EUserAuthQueryKey.USER_AUTH_DETAILS],
        })
      return data
    },
  })
}

export const useUserStartVideoKyc = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (data: UserVideoKYCStartInput) =>
      kycService.startVideoKyc(data),
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EUserAuthQueryKey.USER_AUTH_DETAILS],
        })
      return data
    },
  })
}

export const useUserUploadVideoKycDocument = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (formData: FormData) =>
      kycService.uploadVideoKycDocument(formData),
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EUserAuthQueryKey.USER_AUTH_DETAILS],
        })
      return data
    },
  })
}

export const useUserAddVideoKycDocument = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (data: UserAddVideoDocumentInput) =>
      kycService.addVideoKycDocument(data),
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EUserAuthQueryKey.USER_AUTH_DETAILS],
        })
      return data
    },
  })
}

export const useUserVerifyPersonalInfo = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (data: UserQuickKYCVerifyInput) =>
      kycService.verifyPersonalInfo(data),
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EUserAuthQueryKey.USER_AUTH_DETAILS],
        })
      return data
    },
  })
}
